import React, { useEffect, useState } from 'react';
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SelectMultipleOptionPanier from '../../../SelectMultipleOptionPanier';


// let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchFinancement  : Params = { CodeAgence: '', Table: "TypeGarantie", Colonne1: "CodeTypeGarantie", Colonne2: "LibelleGarantie", Colagence: '101', Choix: 22 }
let searchPlancp: Params= { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL",Colagence: "", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
  
  // let searchOperat: Params = {
  //   CodeAgence: '',
  //   Table: "OPERAT",
  //   Colonne1: "CODOPE",
  //   Colonne2: "LIBELL",
  //   Colagence: '101',
  //   Choix: 22
  // };

  let searchActif: Params = {
    CodeAgence: '',
    Table: "CategorieActif",
    Colonne1: "CodeCategorie",
    Colonne2: "Libelle",
    Colagence: '101',
    Choix: 22
  };

function Tab3(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  
 
  return (
    <div className='tabItem'>
 
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
           <Grid container spacing={0}>
            <Grid item xs={12} md={6}  lg={6} >
                <SelectMultipleOptionPanier notRequired  form={props.form}  Size="large"  width={5}  label="Categorie d'actif"  name="CategorieActifsMourabaha"  Parametre={searchActif} />
             </Grid>
          {/* ActifsMourabaha ,@ActifsMourabaha,Planfours*/}
             <Grid item xs={12} md={6}  lg={6} >
                 <SelectMultipleOptionPanier   form={props.form} Size="large"  width={5}  label="Plan remboussement"  name="ComptesRemboursementAuto" Parametre={searchPlancp}  />
           </Grid>

            {/* <Grid item xs={12} md={6}  lg={6}>
            <SelectMultipleOptionPanier form={props.form} width={5}  Size="large"  label="Frais"  name="Frais"
              Parametre={searchOperat}/>
          </Grid> */}

             {/* <Grid item xs={12} md={6}  lg={6} >
                <SelectMultipleOptionPanier   form={props.form}  Size="large"  width={5}  label="Plan Paiement fournissuer"  name="Planfours"  Parametre={searchPlancp} />
             </Grid>  */}

             <Grid item xs={12} md={6}  lg={6} >
                <SelectMultipleOptionPanier   form={props.form}  Size="large"  width={5}  label="Type de Garantie Autorise"  name="TypeGarantieAuto"  Parametre={searchFinancement} />
             </Grid>
           </Grid>
        </Box>
      </div>

  )
}

export default Tab3;  
